<script setup lang="ts">
  import { Chip, ChipSize } from '@travelata-libs/ui-kit';
  import { computed } from 'vue';
  import { FLEXIBLE_OPTIONS } from '@/entities/searchCriteria';
  import { STAY_DATES_TEXTS } from '../config/texts';
  import { flexCountWord } from '../lib/formatDateLabel';

  interface DateFromFlexChipsProps {
    value: number;
    withExactOption?: boolean;
  }

  const props = withDefaults(defineProps<DateFromFlexChipsProps>(), {
    withExactOption: false,
  });

  const options = computed<number[]>(() => (props.withExactOption ? [0, ...FLEXIBLE_OPTIONS] : [...FLEXIBLE_OPTIONS]));

  const isSegmented = computed<boolean>(() => !props.withExactOption);

  function getChipLabel(daysFlexible: number): string {
    return daysFlexible === 0 ? STAY_DATES_TEXTS.exactDates : `±${flexCountWord(daysFlexible)}`;
  }

  interface DateFromFlexChipsEmits {
    (e: 'select', n: number): void;
  }

  const emit = defineEmits<DateFromFlexChipsEmits>();
</script>

<template>
  <div
    :class="['date-from-flex', { 'date-from-flex_segmented': isSegmented }]"
    data-testid="date-from-flex"
  >
    <Chip
      v-for="(n, i) in options"
      :key="n"
      :appearance="isSegmented ? 'filled' : 'outlined'"
      :size="ChipSize.M"
      :active="value === n"
      :left-rounded="isSegmented && i === 0"
      :right-rounded="isSegmented && i === options.length - 1"
      :data-testid="`date-from-flex-${n}`"
      @click="emit('select', n)"
    >
      {{ getChipLabel(n) }}
    </Chip>
  </div>
</template>

<style scoped lang="scss">
  .date-from-flex {
    align-items: center;
    display: flex;
    gap: var(--spacing-xs);

    &_segmented {
      gap: var(--spacing-xxxs);
    }
  }
</style>
